import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class AssignedGrievanceViewService {

  constructor(public httpClient:HttpClient) { }


  async loadSingalGrievenceById(id:any) {   
    const data={
      'complaintId':id
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadForTransfer,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


 


async transferTo(data){
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.updateGrievForTransfer,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async loadGrievance(deptid: any,bordId:any) {

    const data = { 'depId': deptid, 'bdId':bordId};
    return new Promise((resolve) => {
      this.httpClient
        // .post(ApiUrls.loadGrievanceByDpid, data)
        .post(ApiUrls.loadGrievanceByDpidV2, data)

        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


  async loadUser(data){
   
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadUserByDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


      //load departments type rest
      async loadDepartments(boardId: any) {
        const data = { 'bdId': boardId, };
        return new Promise((resolve) => {
          this.httpClient
            .post(ApiUrls.loadDepartment, data)
            .toPromise()
            .then((res) => {
              resolve(res);
            })
            .catch((resp: Response) => {
              resolve(resp);
            });
        });
      }
      //
}
